import {
  IModifyParamsToSend,
  IParamsToSend
} from '@base/@types/providers/Kpi/RuptureProvider'

import { formattedDate } from './formattedDateKpi'

export const paramsToSendMapping = ({
  name,
  value,
  compareName,
  fieldName,
  paramsToSend
}: IModifyParamsToSend) => {
  const paramsToSendFormatted: IParamsToSend = { ...paramsToSend }

  if (
    name === 'initialDate' ||
    name === 'finalDate' ||
    name === 'periodoIds' ||
    name === 'periodoSelectIds'
  ) {
    paramsToSendFormatted.periodo = {
      inicio:
        name === 'initialDate'
          ? formattedDate(String(value))
          : paramsToSendFormatted.periodo.inicio,
      final:
        name === 'finalDate'
          ? formattedDate(String(value))
          : paramsToSendFormatted.periodo.final,
      agrupar:
        name === 'periodoIds' ? value : paramsToSendFormatted.periodo.agrupar
    }

    return paramsToSendFormatted
  }

  if (name === 'curvaAbcIds' || name === 'curvaAbcSelectIds') {
    paramsToSendFormatted.curvaABC = {
      agrupar:
        typeof value === 'boolean'
          ? value
          : paramsToSendFormatted.curvaABC.agrupar,
      descricoes:
        typeof value === 'object'
          ? value.map(item => item.value)
          : paramsToSend.curvaABC.descricoes
    }

    return paramsToSendFormatted
  }

  if (name === compareName) {
    paramsToSendFormatted[fieldName] = {
      agrupar:
        typeof value === 'boolean'
          ? value
          : paramsToSendFormatted[fieldName].agrupar,
      ids:
        typeof value === 'object'
          ? value.map(item => item.value)
          : paramsToSend[fieldName].ids
    }
  }

  return paramsToSendFormatted
}
